
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]/edit",
      function () {
        return require("private-next-pages/blog/[slug]/edit/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[slug]/edit"])
      });
    }
  